import {
    ADD_EMAIL,
    ADD_EMAIL_FAILURE,
    ADD_EMAIL_SUCCESS,
    APPROVE_ARTIST,
    APPROVE_ARTIST_FAILURE,
    APPROVE_ARTIST_SUCCESS,
    CHANGE_ARTIST_STATUS,
    CHANGE_ARTIST_STATUS_FAILURE,
    CHANGE_ARTIST_STATUS_SUCCESS,
    DELETE_ARTIST,
    DELETE_ARTIST_FAILURE,
    DELETE_ARTIST_SUCCESS,
    GET_ARTIST_LISTING,
    GET_ARTIST_LISTING_FAILURE,
    GET_ARTIST_LISTING_SUCCESS,
} from "../constants";

const initialState = {
    isLoading: false,
    locationLoader: false,
    editEmailLoader: false,
    approveLoader: false,
    locations: [],
    artists: [],
    count: 0,
    deleted: 0,
    artist: {},
    error: null,
};

export default function ArtistReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ARTIST_LISTING:
        case CHANGE_ARTIST_STATUS:
            state = {
                artists: [],
                count: 0,
                deleted: 0,
                artist: {},
                error: null,
                isLoading: true,
            };
            break;
        case GET_ARTIST_LISTING_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                count: action.payload.total,
                artists: action.payload.records,
                deleted: action.payload.deleted,
            };
            break;
        case CHANGE_ARTIST_STATUS_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                error: null,
            };
            break;
        case GET_ARTIST_LISTING_FAILURE:
        case CHANGE_ARTIST_STATUS_FAILURE:
            state = {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            break;
        case DELETE_ARTIST:
        case DELETE_ARTIST_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                error: null,
            };
            break;
        case DELETE_ARTIST_FAILURE:
            state = {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            break;

        case ADD_EMAIL:
            state = {
                ...state,
                error: null,
                editEmailLoader: true,
            };
            break;

        case ADD_EMAIL_SUCCESS:
            state = {
                ...state,
                editEmailLoader: false,
                error: null,
            };
            break;

        case ADD_EMAIL_FAILURE:
            state = {
                ...state,
                editEmailLoader: false,
                error: action.payload,
            };
            break;


        case APPROVE_ARTIST:
            state = {
                ...state,
                error: null,
                approveLoader: true,
            };
            break;

        case APPROVE_ARTIST_SUCCESS:
            state = {
                ...state,
                approveLoader: false,
                error: null,
            };
            break;

        case APPROVE_ARTIST_FAILURE:
            state = {
                ...state,
                approveLoader: false,
                error: action.payload,
            };
            break;

        default:
            break;
    }

    return state;
}
